<div class="max-w-4xl mx-auto py-6 px-6 space-y-5">
  <div class="flex items-start justify-between">
    <div>
      <h2 class="text-sm font-semibold text-gray-900 dark:text-white">URLs donde se muestra el formulario</h2>
      <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">El form se evalúa en orden ascendente. Las reglas marcadas como exclusión ocultan el form en URLs que coinciden.</p>
    </div>
    <button (click)="openDraft()" [disabled]="draft !== null"
      class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-60 transition-colors">
      <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
      Añadir regla
    </button>
  </div>

  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl overflow-hidden">
    <table class="w-full text-sm">
      <thead>
        <tr class="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-800/50">
          <th class="w-16 px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Orden</th>
          <th class="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Tipo</th>
          <th class="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Patrón</th>
          <th class="w-28 px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Exclusión</th>
          <th class="w-32 bg-gray-50 dark:bg-gray-800/50"></th>
        </tr>
      </thead>
      <tbody>

        <!-- Borrador (nuevo) -->
        @if (draft) {
          <tr class="border-b border-gray-100 dark:border-gray-800 bg-brand-50/40 dark:bg-brand-500/5">
            <td class="px-4 py-2">
              <input type="number" [(ngModel)]="draft.sortOrder" min="0" class="w-14 px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
            </td>
            <td class="px-4 py-2">
              <select [(ngModel)]="draft.matchType" class="px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                @for (mt of matchTypes; track mt.value) { <option [ngValue]="mt.value">{{ mt.label }}</option> }
              </select>
            </td>
            <td class="px-4 py-2">
              <input type="text" [(ngModel)]="draft.urlPattern" placeholder="/precios" class="w-full px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
            </td>
            <td class="px-4 py-2">
              <input type="checkbox" [(ngModel)]="draft.isExclusion" class="w-4 h-4 cursor-pointer accent-brand-500" />
            </td>
            <td class="px-4 py-2 text-right">
              <button (click)="submitDraft()" [disabled]="saving" class="px-2 py-1 text-xs font-medium rounded bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-60 transition-colors">Guardar</button>
              <button (click)="cancelDraft()" class="ml-1 px-2 py-1 text-xs text-gray-500 hover:text-gray-700">Cancelar</button>
            </td>
          </tr>
        }

        <!-- Filas existentes -->
        @if (loading && urls.length === 0) {
          <tr><td colspan="5" class="px-4 py-6 text-center text-sm text-gray-500 dark:text-gray-400">Cargando…</td></tr>
        } @else if (!loading && urls.length === 0 && !draft) {
          <tr><td colspan="5" class="px-4 py-8 text-center text-sm text-gray-500 dark:text-gray-400">Sin reglas — el formulario no se mostrará automáticamente en ninguna URL.</td></tr>
        }

        @for (url of urls; track url.id) {
          @if (isEditing(url.id)) {
            <tr class="border-b border-gray-100 dark:border-gray-800 bg-warning-50/40 dark:bg-warning-500/5">
              <td class="px-4 py-2">
                <input type="number" [(ngModel)]="editingById[url.id].sortOrder" min="0" class="w-14 px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
              </td>
              <td class="px-4 py-2">
                <select [(ngModel)]="editingById[url.id].matchType" class="px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  @for (mt of matchTypes; track mt.value) { <option [ngValue]="mt.value">{{ mt.label }}</option> }
                </select>
              </td>
              <td class="px-4 py-2">
                <input type="text" [(ngModel)]="editingById[url.id].urlPattern" class="w-full px-2 py-1 text-xs rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
              </td>
              <td class="px-4 py-2">
                <input type="checkbox" [(ngModel)]="editingById[url.id].isExclusion" class="w-4 h-4 cursor-pointer accent-brand-500" />
              </td>
              <td class="px-4 py-2 text-right">
                <button (click)="submitEdit(url.id)" [disabled]="saving" class="px-2 py-1 text-xs font-medium rounded bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-60 transition-colors">Guardar</button>
                <button (click)="cancelEdit(url.id)" class="ml-1 px-2 py-1 text-xs text-gray-500 hover:text-gray-700">Cancelar</button>
              </td>
            </tr>
          } @else {
            <tr class="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50/50 dark:hover:bg-gray-800/30">
              <td class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ url.sortOrder }}</td>
              <td class="px-4 py-2 text-gray-700 dark:text-gray-300">{{ matchTypeLabel(url.matchType) }}</td>
              <td class="px-4 py-2 font-mono text-xs text-gray-700 dark:text-gray-300">{{ url.urlPattern }}</td>
              <td class="px-4 py-2">
                @if (url.isExclusion) {
                  <span class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-error-50 text-error-700 dark:bg-error-500/15 dark:text-error-400">Sí</span>
                } @else {
                  <span class="text-gray-400">—</span>
                }
              </td>
              <td class="px-4 py-2 text-right">
                <button (click)="startEdit(url)" class="px-2 py-1 text-xs text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">Editar</button>
                @if (isAdmin) {
                  <button (click)="confirmDelete(url)" class="ml-1 px-2 py-1 text-xs text-error-600 hover:text-error-700 dark:text-error-400">Borrar</button>
                }
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
